<i class="{{ classList }}" aria-hidden="true"></i>
